/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from '@emotion/react';
import React from 'react';
import Lottie from 'lottie-react';
import Icon from '../icons/Icon';
import CircularSpinner from '../assets/CircularSpinner.png';
import './Loader.scss';

const SPINNER_SIZE = 48;

export type SpinnerInfo =
  | {
      type: 'logo';
    }
  | {
      type: 'img';
      src: string;
    }
  | {
      type: 'lottie';
      width?: number;
      height?: number;
      data: unknown;
    }
  | {
      type: 'svg';
      data: string;
    }
  | { type: undefined | 'circle' };

export type Props = {
  text?: string;
  // It is being used
  // eslint-disable-next-line react/no-unused-prop-types
  sx?: React.CSSProperties;
} & SpinnerInfo;

function getSpinner(props: Props): React.ReactNode {
  switch (props.type) {
    case 'logo':
      return (
        <Icon
          sx={{
            ...props.sx,
          }}
          icon="pinwheelLogo"
          className="origami-Loader__spinner"
          color="#1170FF"
          size={SPINNER_SIZE}
          viewBox="0 0 32 32"
        />
      );
    case 'lottie':
      return (
        <Lottie
          height={props.width || SPINNER_SIZE}
          width={props.height || SPINNER_SIZE}
          animationData={props.data}
          loop
          autoplay
          style={{
            height: `${props.width || SPINNER_SIZE}px`,
            width: `${props.height || SPINNER_SIZE}px`,
          }}
        />
      );
    case 'img':
      return (
        <img
          css={{
            maxWidth: `${SPINNER_SIZE}px`,
            maxHeight: `${SPINNER_SIZE}px`,
            ...props.sx,
          }}
          alt="Spinning circle"
          src={props.src}
          data-testid="Loader-Circle-Spinner"
          className="origami-Loader__spinner origami-Loader__spinner-img-circle origami-Loader__spinner--reverse"
        />
      );
    default:
      return (
        <img
          css={{
            maxWidth: `${SPINNER_SIZE}px`,
            maxHeight: `${SPINNER_SIZE}px`,
            ...props.sx,
          }}
          alt="Spinning circle"
          src={CircularSpinner}
          data-testid="Loader-Circle-Spinner"
          className="origami-Loader__spinner origami-Loader__spinner-img-circle origami-Loader__spinner--reverse"
        />
      );
  }
}

const Loader: React.FC<Props> = (props) => {
  const { text } = props;
  return (
    <div data-testid="Loader" className="origami-Loader">
      <div className="origami-Loader__spinner-container">
        {getSpinner(props)}
      </div>
      {text ? (
        <div className="origami-Loader__spinner-text" data-testid="Loader-text">
          {text}
        </div>
      ) : null}
    </div>
  );
};

export default Loader;
